import Modal from '@/components/modals/modal/modal.vue'
import emitHideMixin from '@/components/modals/mixins/emit-hide'

export default {
  name: 'EditSingleSettingModal',
  mixins: [emitHideMixin],
  components: {
    Modal
  },
  props: {
    schema: {
      type: Array,
      default: () => []
    },
    manufactures: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      manufactureId: null,
      settingKey: null,
      value: '',
      originalValue: '',
      pending: false
    }
  },
  computed: {
    column() {
      return this.schema.find(col => col.key === this.settingKey) || null
    },
    manufacture() {
      return this.manufactures.find(m => m.manufacture_id === this.manufactureId) || null
    },
    settingTitle() {
      return this.column?.title ?? ''
    },
    manufactureTitle() {
      return this.manufacture?.manufacture_title ?? ''
    },
    measureUnit() {
      return this.column?.measure_unit ?? ''
    },
    isSaveDisabled() {
      if (this.pending) return true
      if (this.value === '' || this.value === null) return true
      return String(this.value) === String(this.originalValue)
    }
  },
  methods: {
    show(manufactureId, settingKey) {
      this.manufactureId = manufactureId
      this.settingKey = settingKey
      const manufacture = this.manufactures.find(m => m.manufacture_id === manufactureId)
      this.value = manufacture?.settings?.[settingKey] ?? ''
      this.originalValue = this.value
      this.pending = false
      this.$refs.modal.show()
      this.$nextTick(() => {
        this.$refs.input && this.$refs.input.focus()
      })
    },

    async onSubmit() {
      this.pending = true
      try {
        this.$emit('save', {
          manufactures: [{
            manufacture_id: this.manufactureId,
            settings: { [this.settingKey]: String(this.value) }
          }]
        })
        this.hide()
      } catch (error) {
        console.error('Failed to save setting:', error)
      } finally {
        this.pending = false
      }
    }
  }
}
